import { OptionModel } from "../../common/types/OptionModel";

export const insertCustomerWithExcelUserNameOptions: OptionModel[] =[
    {
        value: 1,
        label: "Müşteri Kodu"
    },
    {
        value: 3,
        label: "Vergi Numarası"
    },
    {
        value: 12,
        label: "Email Adresi"
    }
];